// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper_1eMug","buttons":"style_buttons_2027J","title":"style_title_3nfJO"};